import { render, staticRenderFns } from "./HomeQuotes.vue?vue&type=template&id=6df2dad1&"
import script from "./HomeQuotes.vue?vue&type=script&lang=js&"
export * from "./HomeQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports